import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CollapsibleSection = ({
    title = '', initiallyExpanded = false, children, titleChildren,
}) => {
    const [isExpanded, setIsExpanded] = useState(initiallyExpanded);

    return (
        <div className="collapsible-section max-width-540px margin-b-16px">
            <button
                onClick={() => { setIsExpanded((prev) => !prev); }}
                className="collapsible-section__button cursor-pointer flex align-items-end justify-content-space-between bg-transparent border-none align-items-center pad-l-0px pad-b-24px width-100"
                type="button"
                aria-expanded={isExpanded}
                aria-controls="collapsible-content"
            >
                <span className="collapsible-section__title">{ title }</span>
                <i
                    className={isExpanded ? 'fa fa-angle-down' : 'fa fa-angle-up'}
                    aria-hidden="true"
                ></i>
            </button>
            {!isExpanded && titleChildren && <span className="collapsible-section__title__children">
                {titleChildren}
            </span>}
            <div id='collapsible-content'>
                {isExpanded
                    ? children
                    : null}
            </div>
        </div>
    );
};

CollapsibleSection.propTypes = {
    title: PropTypes.string.isRequired,
    initiallyExpanded: PropTypes.bool,
    children: PropTypes.node.isRequired,
    titleChildren: PropTypes.node,
};

export default CollapsibleSection;
